import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './index.scss';

const InfoField = ({
  className,
  labelClassName,
  valueClassName,
  isFullWidthMobile,
  label,
  value,
  info,
}) => {
  const containerClassNames = cn('info-field', className);
  const labelClassNames = cn('info-field__label', labelClassName);
  const valueClassNames = cn('info-field__value', valueClassName, {
    'info-field__value--fixed-width-mobile': !isFullWidthMobile,
    'info-field__value--full-width-mobile': isFullWidthMobile,
  });
  const infoClassNames = cn('info-field__info', valueClassName);

  return (
    <div className={containerClassNames}>
      <div className={labelClassNames}>{label}</div>
      {value && <div className={valueClassNames}>{value}</div>}
      <div className={infoClassNames}>{info}</div>
    </div>
  );
};

InfoField.propTypes = {
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  valueClassName: PropTypes.string,
  isFullWidthMobile: PropTypes.bool,
  label: PropTypes.node,
  value: PropTypes.node,
  info: PropTypes.node,
};

InfoField.defaultProps = {
  className: '',
  labelClassName: '',
  valueClassName: '',
  isFullWidthMobile: false,
  label: undefined,
  value: undefined,
  info: undefined,
};

export default InfoField;
